var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.259,
    height: 12.276,
    viewBox: "0 0 12.259 12.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M8.014.141.5,7.652a.518.518,0,0,0-.146.332L.3,11.808a.453.453,0,0,0,.146.34.483.483,0,0,0,.34.129H.794l3.711-.032a.47.47,0,0,0,.34-.129l7.576-7.576a.493.493,0,0,0,0-.687L8.7.133A.5.5,0,0,0,8.014.141ZM4.3,11.29l-3.016.04.049-3.137L6.341,3.181,9.373,6.213Zm5.757-5.757L7.028,2.5,8.362,1.167,11.386,4.2Z",
    transform: "translate(-0.301 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.39f93d3610c1be4e143f21d841f96aec.svg";
export { ForwardRef as ReactComponent };